import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskedLines, FadeIn } from "@/components/site/Motion";
import { TiltPhone } from "@/components/site/TiltPhone";
export const Hero = () => {
  return (
    <section className="relative overflow-hidden pb-20 pt-32 sm:pt-40 lg:pb-28" data-testid="hero-section">
      <div className="bg-grid pointer-events-none absolute inset-0" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-7">
          <FadeIn>
            <span className="inline-flex items-center gap-2 rounded-full border border-[#e7e7ea] bg-white px-3.5 py-1.5 text-xs font-semibold text-[#111111] shadow-sm sm:text-sm" data-testid="hero-badge">
              <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#0066FF] opacity-60" /><span className="relative inline-flex h-2 w-2 rounded-full bg-[#0066FF]" /></span>
              Tool n.1 · Disponibile ora - MIMIS VIDEO
            </span>
          </FadeIn>
          <h1 className="font-display mt-7 font-extrabold tracking-tight text-[#111111]" data-testid="hero-title">
            <MaskedLines
              delay={0.15}
              lines={[
                { text: "MIMIS", className: "text-[5.2rem] leading-[0.9] tracking-[-0.05em] sm:text-[8rem] lg:text-[9.5rem]" },
                { text: "— Mr & Ms —", className: "text-4xl leading-[1.1] text-[#a1a1aa] sm:text-5xl lg:text-6xl" },
                { text: "Piattaforma SaaS", className: "text-4xl leading-[1.1] sm:text-5xl lg:text-6xl" },
                { text: "Amichevole.", className: "text-4xl leading-[1.1] text-[#0066FF] sm:text-5xl lg:text-6xl" },
              ]}
            />
          </h1>
          <FadeIn delay={0.75}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-[#52525b] md:text-lg" data-testid="hero-subtitle">
              L'Hub di App che Risolvono Problemi Veri. Il primo Tool è disponibile ora: <span className="font-semibold text-[#111111]">crea video virali in 60 secondi.</span>
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link to="/tool/mimis-video" className="btn-blu h-14 px-7 text-base" data-testid="hero-try-button">
                Crea il tuo video gratis <ArrowRight className="arrow h-4 w-4" />
              </Link>
              <Link to="/tool/mimis-video#prezzo" className="btn-ghost h-14 px-7 text-base" data-testid="hero-tool-link">
                Vedi i piani <ArrowRight className="arrow h-4 w-4" />
              </Link>
            </div>
            <p className="mt-5 text-sm text-[#71717a]">Primo video gratis · Nessuna carta richiesta · Accesso con Google</p>
          </FadeIn>
        </div>
        <div className="lg:col-span-5">
          <TiltPhone />
        </div>
      </div>
    </section>
  );
};
